import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { employeProtocolActions } from "@store/actions";

import BackButton from "@components/tailwindComponents/BackButton";
import DotLoader from "@components/tailwindComponents/DotLoader";

import { DocumentStorage } from "@services/all.services";

import EmployeTaskList from "./EmployeTaskList";
import LoadProtocolHeader from "./LoadProtocolHeader";

export default function LoadProtocol(props) {
  const reduxDispatch = useDispatch();

  const [employeFolders, setEmployeFolders] = useState([]);
  const employeProtocol = useSelector(
    ({ onboarding }) => onboarding.employeProtocol
  );

  useEffect(() => {
    if (employeProtocol.metadata.employeeId) {
      const employeProtocolId = employeProtocol.metadata.employeProtocolId;
      reduxDispatch(employeProtocolActions.loadData(employeProtocolId));
      loadDocumentStorages(employeProtocol.metadata.employeeId);
    }
  }, [employeProtocol.metadata.employeeId]);

  async function loadDocumentStorages(employeId) {
    const response = await DocumentStorage.getAllDocsByEmployer(employeId);
    const documentStorages = response?.data?.data || [];

    const folders = documentStorages
      .filter(
        (ds) =>
          ds.type === "folder" &&
          !ds.isALink &&
          (ds.originalName || ds.wasabiName)
      )
      .map((ds) =>
        ds.originalName ? ds : { ...ds, originalName: ds.wasabiName }
      );

    setEmployeFolders(folders);
  }

  if (employeProtocol.isLoading) {
    return (
      <div className="arh-h-screen">
        <DotLoader size="small" />
      </div>
    );
  }

  return (
    <div className="arh-bg-white arh-p-4 arh-px-9 arh-h-[100vh] arh-overflow-y-auto">
      <div className="arh-pb-[1.063rem] arh-pt-0">
        <BackButton onClick={props.onBackClicked} />
      </div>

      <div className="arh-space-y-4 arh-pl-[30px]">
        <LoadProtocolHeader
          selectedEmployeProtocol={employeProtocol.selected}
          employeProtocolMetadata={employeProtocol.metadata}
        />
        {employeProtocol.selected ? (
          <EmployeTaskList
            employeProtocol={employeProtocol.selected}
            employeFolders={employeFolders}
          />
        ) : null}
      </div>
    </div>
  );
}
